import React, { useState, useEffect } from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

// Importar los estilos
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

const PDFModalViewer = ({ fileUrl }) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const [initialZoom, setInitialZoom] = useState(1); // 1 = 100%

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 600) {
        // Mobile
        setInitialZoom(0.4);
      } else if (width >= 600 && width < 1024) {
        // Tablet
        setInitialZoom(0.6);
      } else {
        // Desktop
        setInitialZoom(1);
      }
    };

    handleResize();

    // Escuchar cambios de tamaño
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={{ height: '85vh', width: '100%' }}>
      {/* Worker para visualizar los pdf, el archivo original es pesado asi que se utilizo CDN */}
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
        <Viewer
          fileUrl={fileUrl}
          plugins={[defaultLayoutPluginInstance]}
          initialScale={initialZoom}
          key={initialZoom}
        />
      </Worker>
    </div>
  );
};

export default PDFModalViewer;
